import PropTypes from 'prop-types';
import SubscriptionDetail from '../../components/subscription/SubscriptionDetail/SubscriptionDetail';
import usePlanSettingsPresenter from '../../presenters/PlanSettings/usePlanSettingsPresenter';

export const PlanSettingsContainer = ( { workspaceID } ) => {
	const presenter = usePlanSettingsPresenter( { workspaceID } );
	return (
		<>
			<SubscriptionDetail
				presenter={presenter}
			/>
		</>
	);
};

PlanSettingsContainer.propTypes = {
	workspaceID: PropTypes.number.isRequired
};

export default PlanSettingsContainer;
